import styled from '@emotion/styled'
import {
  PopoverProps,
  Content as RadixContent,
  Root as RadixRoot,
  Trigger as RadixTrigger,
} from '@radix-ui/react-popover'

import { theme } from '../constants'

const Content = styled(RadixContent)({
  zIndex: theme.zIndex.popover,
})

export const Popover = (props: PopoverProps) => {
  return <RadixRoot {...props} />
}

Popover.Trigger = RadixTrigger
Popover.Content = Content
